import {
  iconRoadsideAssistance,
  iconInspection,
  iconBluelink,
  iconPowertrainWarranty,
} from 'client/images/inline-svgs/ads/cpo-icons';

// Do not use array for CPO_PRODUCT_SKU, only string.
export const CPO_PRODUCT_SKU = 'CP011';

export const CPO_KIA_MAKE_NAME = 'kia';
export const CPO_MERCEDES_BENZ_MAKE_NAME = 'mercedes-benz';

export const CPO_FEATURE_NAMES = {
  default: [
    {
      name: '173-point inspection',
      icon: iconInspection,
      disclaimer:
        '*Electric, hybrid and plug-in hybrid vehicles may subject to a different number of inspection points.',
    },
    {
      name: 'Powertrain Warranty',
      icon: iconPowertrainWarranty,
      disclaimer:
        '*Hyundai Motor America offers a 10-Year/100,000-Mile Powertrain Limited Warranty on Certified Used Vehicles, starting at original in-service date and zero (0) miles. $50 deductible per repair visit applies. See a participating Hyundai dealer for program details and limitations. See the HCUV Limited Warranty Provisions Details for more information on Powertrain Warranty Transfers.',
    },
    {
      name: 'Roadside Assistance',
      icon: iconRoadsideAssistance,
      disclaimer:
        '*Six (6) free Roadside Events during each 12-month period of coverage during warranty period of 10 years from original in-service date and zero (0) miles.',
    },
    {
      name: 'Bluelink®+ Trial',
      icon: iconBluelink,
      disclaimer:
        '*2023 IONIQ 6 and all 2024 and newer model year vehicles include Bluelink+ Basic for the lifetime of vehicle ownership. Bluelink+ requires an active Bluelink account subject to the Connected Services Terms and Conditions. 2023 IONIQ 6 and all 2024 and newer model year Hyundai Certified Used Vehicles include a one-year Bluelink+ Advanced trial.  Other 2023 and older model year Hyundai Certified Used Vehicles include a three-month trial of Bluelink® Connected Car package. Bluelink is not available on all models and trims.  Bluelink features vary by model and trim.',
    },
  ],
  [CPO_KIA_MAKE_NAME]: [
    {
      name: '165-point inspection',
      icon: iconInspection,
      disclaimer:
        '*Each Kia Certified Pre-Owned vehicle goes through a rigorous 165-point inspection, ensuring it meets Kia’s stringent standards to provide you with a quality, factory-backed vehicle.',
    },
    {
      name: 'Powertrain Warranty',
      icon: iconPowertrainWarranty,
      disclaimer:
        '*The Kia CPO 10-year/100,000-mile limited warranty program begins on the original in-service date of vehicle and odometer mile "0." The limited warranty program includes the remainder of roadside assistance, powertrain coverage and the New Vehicle Limited Warranty (Basic). See retailer for details.',
    },
    {
      name: 'Roadside Assistance',
      icon: iconRoadsideAssistance,
      disclaimer:
        "*Cross Country Motor Club Driver's OneCard Membership, that includes:  - Flat Tire: Change your flat tire with your  inflated spare -  Out of Gas: Arrange to have up to three  gallons of free gas delivered if your vehicle runs out of fuel-  Lockout: Assist in getting vehicle unlocked if the keys are lost, broken or locked inside  your vehicle- Jump-Start: Arrange a battery jump.",
    },
  ],
  [CPO_MERCEDES_BENZ_MAKE_NAME]: [
    {
      name: '165+ point inspection',
      icon: iconInspection,
      disclaimer:
        'The 165+ point inspection applies only to certain Certified Pre-Owned vehicles with internal combustion engines. Different inspection points apply for electric vehicles. Inspection details may vary based on vehicle type, age, mileage, or other factors. Please see your authorized Mercedes-Benz dealer for details',
    },
    {
      name: 'Limited Warranty',
      icon: iconPowertrainWarranty,
      disclaimer:
        '*Under the Certified Pre-Owned Limited Warranty, any authorized Mercedes-Benz dealer will make the necessary repairs or replacements to correct defects in material or workmanship. Components covered include, but are not limited to:<br/><br/>' +
        'Engine Components<br/>' +
        'Powertrain Components<br/>' +
        'Battery state of health (EVs only)<br/>' +
        'Suspension<br/>' +
        'Brakes (excluding normal wear of discs and pads)<br/>' +
        'Steering<br/>' +
        'Electrical Systems<br/>' +
        'Climate Control<br/>' +
        'Audio and Navigation Systems<br/>' +
        'Central Locking<br/>' +
        'Convertible/Retractable Top Systems (if applicable)<br/>' +
        'And more',
    },
    {
      name: 'Roadside Assistance',
      icon: iconRoadsideAssistance,
      disclaimer:
        '*As part of your warranty coverage, you’ll also enjoy complimentary Roadside Assistance. A simple phone call summons help if you need a jump-start, tire change, or if you run out of fuel.',
    },
    {
      name: '7 Days to Exchange',
      icon: iconRoadsideAssistance,
      disclaimer:
        '*To make sure you’re completely satisfied with your Mercedes-Benz, you can exchange it for another model within the first seven days or 500 miles, whichever comes first. Applies to Certified Pre-Owned Mercedes-Benz vehicles purchased on or after January 15, 2014. Customer can exchange his or her vehicle for another Mercedes-Benz CPO vehicle or new Mercedes-Benz vehicle of equal or greater value . Please see your dealer for full details and limitations.',
    },
  ],
};
